<template>
  <div class="active-container all-box" ref="mainContainer">
    <ActiveList :list="datas.records" v-if="datas.records.total !== 0" />
    <div
      class="loading"
      element-loading-text="加载中..."
      v-loading="isLoading"
      v-if="!isNotMore"
      :style="{ paddingTop: datas.records.total !== 0 ? 0 : '150px' }"
    ></div>
    <div class="noMore" v-if="isNotMore">更多活动，敬请期待</div>
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import mainScroll from "@/mixins/mainScroll.js";
import { getActives } from "@/api/active.js";
import ActiveList from "./components/ActiveList";
export default {
  components: {
    ActiveList,
  },
  mixins: [fetchData({ records: { total: 0 } }), mainScroll("mainContainer")],
  data() {
    return {
      page: 1,
      limit: 10,
      isNotMore: false,
    };
  },
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  methods: {
    async fetchData() {
      return await getActives(this.page, this.limit);
    },
    handleScroll(dom) {
      if (this.isLoading || !dom) {
        // 目前正在加载更多
        return;
      }
      const range = 20; // 顶一个可接受的范围，在这个范围内都算达到了底部
      const dec = Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    }, // 加载下一页
    async fetchMore() {
      if (!this.hasMore) {
        // 没有更多啦
        this.isNotMore = true;
        return;
      }
      this.isLoading = true;
      this.page++;

      const resp = await this.fetchData();
      this.datas.records.total = resp.records.total;
      this.datas.records.data = this.datas.records.data.concat(
        resp.records.data
      );

      this.isLoading = false;
    },
  },
  computed: {
    hasMore() {
      return this.datas.records.data.length < this.datas.records.total;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";

.active-container {
  position: relative;
  margin: auto;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  overscroll-behavior-y: none;
  height: 100%;
}

.loading {
  background: transparent;
  margin: 20px 0;
  height: 20px;
}

.noMore {
  color: var(--ccc);
  margin: 20px 0;
  height: 20px;
  font-size: 14px;
}
</style>